import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css';
import 'animate.css';


createApp(App).mount('#app')
